/*
 * 注入样式相关的公共变量
 */

export default function (injection, Vue) {
    injection = window.injection = window.injection || {};
    const cStyle = {
        horizonMargin: 10,
        verticalMargin: 10,
        b64NoImage: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUBBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBf/CABEIAGQAZAMBIgACEQEDEQH/xAAaAAEAAgMBAAAAAAAAAAAAAAAAAgMBBAUI/9oACAEBAAAAAPXYAAAAAAQMGcyDWxdVmE47EhXCaJOYIyADW0OhsCuUirm4z07FHPs6WYcyJZ06efhs7/LrC2vA2tUAAAB//8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAgBAhAAAAAAAAAAAAB//8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAgBAxAAAAAAAAAAAAB//8QAMxABAAIBAgQEAwQLAAAAAAAAAQIRAwASICExQRAyUaETYXFSgbLBBDAzQFBicpGx0fH/2gAIAQEAAT8A/hLkjFIrz05I/wDB0ziArV/J18XH9r2dOSJXVvmUa+LH0k/Q1vjt39tMiIL6h/fizDd8haBttDV+Z3otBp3nTbR3ld6xs262XJZ03dOpbtxfXZLyelx9dRGyjkN7SSTfq9HT+xyfWX4tKJUp5a5dYn+tRE6yZfWuGcGTFK5et/lTpxSTt1O8/wA3U4s2rqHcOsvl8jTCRLdDb0pG/atfDkVzHlLdZ9pOmjHIRJBX9Vfi18OVEVK3MpV352GskWUGJx74XW4v0v8AWZ8202R8z7Hhgy7zbLzHucM8sINLz1CcZlxb4M2Uxn8z0NLbb4CxROprFkMkb7nU8c2YxlHOf+NKra26xZHHK+3c0IlnR8JzMcbfuPV1KbOTJ4Mc3HIkfeepqMiQSOjrNmIFHOb7aW23xwZdjtl5X2fDLkckr7djix5ZYxDv7Oltt4YfpLGJFN1d/wB7/8QAFBEBAAAAAAAAAAAAAAAAAAAAUP/aAAgBAgEBPwBH/8QAFBEBAAAAAAAAAAAAAAAAAAAAUP/aAAgBAwEBPwBH/9k='
    };
    Object.defineProperties(injection, {
        $cStyle: {
            get () {
                return cStyle;
            }
        }
    });
    Object.defineProperties(Vue.prototype, {
        $cStyle: {
            get () {
                return cStyle;
            }
        }
    });
}
